module.exports = ".counter__container {\n  background-color: #194d7f;\n  border-radius: 50%;\n  width: 1.4em;\n  height: 1.4em;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: .95em; }\n  .counter__container .counter {\n    color: #fff;\n    font-weight: 700;\n    font-size: .8em;\n    line-height: 1.4em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/download-status/counter-done-reports/counter-done-reports.scss
// module id = grpP
// module chunks = 12